import React from "react";
import resumeFile from "../documents/resume.pdf";
const AboutUs = ({ classicHeader, darkTheme }) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(resumeFile);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Weichen_Zhang_Resume.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Know Me More
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Weichen Zhang,</span> an
              aspiring Software Engineer
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              Pursuing a Master Degree in Computer Science at UIUC. Skilled in
              Full Stack Development, Distributed Systems, Database
              Optimization, Machine Learning, and real-time processing with
              Apache Kafka. Skills include React, Node.js, Express, PostgreSQL,
              MongoDB, AWS, Docker, and GraphQL, focusing on building scalable,
              robust systems. Passionate about leveraging scalable technologies
              to solve complex challenges and deliver impactful solutions.
            </p>
            {/* <p className={darkTheme ? "text-white-50" : ""}>
              Delivering projects that meet client requirements on time and
              within budget is my priority. My experience spans developing
              decentralized applications, optimizing database performance, and
              deploying solutions using AWS and GCP, ensuring reliable and
              efficient outcomes for every project.
            </p> */}
          </div>
          {/* About me content end */}
          {/* about me personal detials start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Weichen Zhang
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="mailto:chat@simone.com">
                    weichenZhang2025@gmail.com
                  </a>
                </li>
                {/* <li>
                  <span className="fw-600 me-2">Age:</span>22
                </li> */}
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>San Francisco, CA
                </li>
              </ul>
              <button
                onClick={handleDownload}
                className="btn btn-primary rounded-pill"
                type="button"
              >
                Download Resume
              </button>
            </div>
          </div>
          {/* about me personal details end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row">
            <div className="col-6 col-md-4">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>3.66</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>GPA</p>
              </div>
            </div>
            <div className="col-6 col-md-4">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>8</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years' of Coding
                </p>
              </div>
            </div>
            <div className="col-6 col-md-4">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Projects Done
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
